import { useEffect, useRef, useState } from "react";
import CardWrapperSimple from "../CardWrapperSimple";
import { Button, Col, Form, FormGroup, Input, Row } from "reactstrap";
import { useTranslation } from "react-i18next";

const GatherPayeeData = (preps) => {
  const { setPayeeData, defaultFirstname, defaultLastname, defaultEmail } = preps;
  const { t } = useTranslation();
  const firstnameRef = useRef();
  const lastnameRef = useRef();
  const emailRef = useRef();

  const [firstname, setFirstname] = useState(defaultFirstname);
  const [lastname, setLastname] = useState(defaultLastname);
  const [email, setEmail] = useState(defaultEmail);

  // Set focus to form element.
  useEffect(() => {
    if (!defaultFirstname) {
      firstnameRef?.current?.focus();
    } else if (!defaultLastname) {
      lastnameRef?.current?.focus();
    } else if (!defaultEmail) {
      emailRef?.current?.focus();
    }
  }, [defaultEmail, defaultFirstname, defaultLastname]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setPayeeData(firstname, lastname, email);
  };

  return (
    <CardWrapperSimple>
      <div className='mt-4 mb-4'>
        <h2>{t("payee_gathering")}</h2>
      </div>
      <div className='mb-3'>{t("payee-gathering-description")}</div>

      <Form onSubmit={handleSubmit}>
        <Row>
          <Col lg='4'>
            <FormGroup className='mb-4 mt-3'>
              <div className='d-flex justify-content-between'>
                <label htmlFor='firstname' className='font-weight-bold'>
                  {t("firstname")}:
                </label>
              </div>
              <Input
                placeholder={t("firstname-placeholder")}
                id='firstname'
                type='text'
                innerRef={firstnameRef}
                autoComplete='off'
                onChange={(e) => setFirstname(e.target.value)}
                value={firstname}
                disabled={defaultFirstname}
                required
                tabIndex='1'
              />
            </FormGroup>
          </Col>
          <Col lg='4'>
            <FormGroup className='mb-4 mt-3'>
              <div className='d-flex justify-content-between'>
                <label htmlFor='lastname' className='font-weight-bold'>
                  {t("lastname")}:
                </label>
              </div>
              <Input
                id='lastname'
                innerRef={lastnameRef}
                placeholder={t("lastname-placeholder")}
                type='text'
                onChange={(e) => setLastname(e.target.value)}
                value={lastname}
                disabled={defaultLastname}
                required
                tabIndex='2'
              />
            </FormGroup>
          </Col>
          <Col lg='4'>
            <FormGroup className='mb-4 mt-3'>
              <div className='d-flex justify-content-between'>
                <label htmlFor='email' className='font-weight-bold'>
                  Email:
                </label>
              </div>
              <Input
                id='email'
                innerRef={emailRef}
                placeholder={t("email-placeholder")}
                type='email'
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                disabled={defaultEmail}
                required
                tabIndex='3'
              />
            </FormGroup>
          </Col>
        </Row>
        <div className='text-center mt-3 mb-4'>
          <Button
            className=' text-uppercase font-weight-bold font-size-sm'
            color='danger'
            tabIndex='4'
            onClick={handleSubmit}
          >
            {t("continue")}{" "}
          </Button>
        </div>
      </Form>
    </CardWrapperSimple>
  );
};

export default GatherPayeeData;
